import { EnvironmentProviders, Provider, inject, makeEnvironmentProviders } from '@angular/core';
import { Store } from '@ngxs/store';
import { ActionsOnReceive, NotificationPayload } from '@tribuu-shared-notifications';
import {
  NOTIFICATION_HANDLER,
  NotificationHandler,
} from '@core/store/notifications/handler-registry';
import { ProfileActions } from './profile.actions';

/**
 * Registers the identity-verification push-event handler.
 *
 * When the backend fires an IDENTITY_VERIFICATION_UPDATE envelope, this
 * handler triggers a ProfileActions.LoadProfile so the UI reflects the
 * updated `user.identityVerification` flag without polling.
 *
 * Usage: add to the `providers` array of AppModule (or equivalent root provider).
 */
export function provideIdentityVerificationHandler(): Provider {
  return {
    provide: NOTIFICATION_HANDLER,
    useFactory: (): NotificationHandler => {
      const store = inject(Store);
      return {
        action: ActionsOnReceive.IDENTITY_VERIFICATION_UPDATE,
        handler: (_payload: NotificationPayload) => {
          store.dispatch(new ProfileActions.LoadProfile());
        },
      };
    },
    multi: true,
  };
}
